"use strict";
var import_vitest = require("vitest");
var import_environmentGuardPlugin = require("./environmentGuardPlugin");
(0, import_vitest.describe)("environmentGuardPlugin", function() {
  (0, import_vitest.describe)("resolveEnvironmentGuard", function() {
    (0, import_vitest.it)("returns null for non-guard specifiers", function() {
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.resolveEnvironmentGuard)("react", "client")).toBeNull();
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.resolveEnvironmentGuard)("vite", "ssr")).toBeNull();
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.resolveEnvironmentGuard)("some-other-pkg", "ios")).toBeNull();
    });
    (0, import_vitest.it)("returns virtual id for server-only (with consumer)", function() {
      var id = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("server-only", "ssr", "server");
      (0, import_vitest.expect)(id).toBe("\0one-env-guard:server-only:ssr:server");
    });
    (0, import_vitest.it)("returns virtual id for client-only (with consumer)", function() {
      var id = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("client-only", "client", "client");
      (0, import_vitest.expect)(id).toBe("\0one-env-guard:client-only:client:client");
    });
    (0, import_vitest.it)("returns virtual id for native-only", function() {
      var id = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("native-only", "ios");
      (0, import_vitest.expect)(id).toBe("\0one-env-guard:native-only:ios:unknown");
    });
    (0, import_vitest.it)("returns virtual id for web-only", function() {
      var id = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("web-only", "client");
      (0, import_vitest.expect)(id).toBe("\0one-env-guard:web-only:client:unknown");
    });
    (0, import_vitest.it)("encodes worker consumer for cloudflare deploy", function() {
      var id = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("server-only", "worker", "server");
      (0, import_vitest.expect)(id).toBe("\0one-env-guard:server-only:worker:server");
    });
  });
  (0, import_vitest.describe)("loadEnvironmentGuard", function() {
    (0, import_vitest.it)("returns null for non-virtual ids", function() {
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.loadEnvironmentGuard)("react")).toBeNull();
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.loadEnvironmentGuard)("/some/path.ts")).toBeNull();
    });
    (0, import_vitest.it)("server-only: allowed in any server-consumer env", function() {
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:server-only:ssr:server")).toBe("export {}");
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:server-only:worker:server")).toBe("export {}");
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:server-only:edge:server")).toBe("export {}");
    });
    (0, import_vitest.it)("server-only: legacy 2-part form still allowed in ssr", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:server-only:ssr");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
    (0, import_vitest.it)("server-only: forbidden in client", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:server-only:client:client");
      (0, import_vitest.expect)(result).toContain("throw new Error");
      (0, import_vitest.expect)(result).toContain("server-only");
      (0, import_vitest.expect)(result).toContain("client");
    });
    (0, import_vitest.it)("server-only: forbidden in ios", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:server-only:ios:client");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("server-only: forbidden in android", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:server-only:android:client");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("client-only: allowed in client", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:client-only:client:client");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
    (0, import_vitest.it)("client-only: legacy 2-part form still allowed in client", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:client-only:client");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
    (0, import_vitest.it)("client-only: forbidden in ssr", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:client-only:ssr:server");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("client-only: forbidden in ios", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:client-only:ios:server");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("client-only: forbidden in android", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:client-only:android:server");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("native-only: allowed in ios", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:native-only:ios:unknown");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
    (0, import_vitest.it)("native-only: allowed in android", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:native-only:android:unknown");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
    (0, import_vitest.it)("native-only: forbidden in client", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:native-only:client:client");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("native-only: forbidden in ssr", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:native-only:ssr:server");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("web-only: allowed in client", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:web-only:client:client");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
    (0, import_vitest.it)("web-only: allowed in ssr", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:web-only:ssr:server");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
    (0, import_vitest.it)("web-only: allowed in worker", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:web-only:worker:server");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
    (0, import_vitest.it)("web-only: forbidden in ios", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:web-only:ios:unknown");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("web-only: forbidden in android", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:web-only:android:unknown");
      (0, import_vitest.expect)(result).toContain("throw new Error");
    });
    (0, import_vitest.it)("disabled guards always pass", function() {
      var result = (0, import_environmentGuardPlugin.loadEnvironmentGuard)("\0one-env-guard:client-only:disabled");
      (0, import_vitest.expect)(result).toBe("export {}");
    });
  });
  (0, import_vitest.describe)("options", function() {
    (0, import_vitest.it)("disabled: true makes all guards no-ops", function() {
      var id = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("client-only", "ssr", "server", {
        disabled: true
      });
      (0, import_vitest.expect)(id).toBe("\0one-env-guard:client-only:disabled");
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.loadEnvironmentGuard)(id)).toBe("export {}");
    });
    (0, import_vitest.it)("disableGuards: disables specific guard types", function() {
      var id1 = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("client-only", "ssr", "server", {
        disableGuards: [
          "client-only"
        ]
      });
      (0, import_vitest.expect)(id1).toBe("\0one-env-guard:client-only:disabled");
      var id2 = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("server-only", "client", "client", {
        disableGuards: [
          "client-only"
        ]
      });
      (0, import_vitest.expect)(id2).toBe("\0one-env-guard:server-only:client:client");
      (0, import_vitest.expect)((0, import_environmentGuardPlugin.loadEnvironmentGuard)(id2)).toContain("throw new Error");
    });
    (0, import_vitest.it)("disableGuards: can disable multiple guards", function() {
      var id1 = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("client-only", "ssr", "server", {
        disableGuards: [
          "client-only",
          "server-only"
        ]
      });
      (0, import_vitest.expect)(id1).toBe("\0one-env-guard:client-only:disabled");
      var id2 = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("server-only", "client", "client", {
        disableGuards: [
          "client-only",
          "server-only"
        ]
      });
      (0, import_vitest.expect)(id2).toBe("\0one-env-guard:server-only:disabled");
      var id3 = (0, import_environmentGuardPlugin.resolveEnvironmentGuard)("native-only", "client", "client", {
        disableGuards: [
          "client-only",
          "server-only"
        ]
      });
      (0, import_vitest.expect)(id3).toBe("\0one-env-guard:native-only:client:client");
    });
  });
});
//# sourceMappingURL=environmentGuardPlugin.test.js.map
